import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Job & Project Module Service Stores
 */
export const jobStores: ServiceStoreConfig[] = [
  {
    name: "job",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.jobStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalJobs = entities.length;
          const activeJobs = entities.filter(
            (job: Record<string, unknown>) => !job.archived
          ).length;
          const highPriorityJobs = entities.filter(
            (job: Record<string, unknown>) =>
              job.priority === "High" || job.priority === "Critical"
          ).length;
          const totalBudget = entities.reduce(
            (sum: number, job: Record<string, unknown>) => {
              return sum + ((job.budget as number) || 0);
            },
            0
          );

          return [
            {
              title: "Total Jobs",
              value: () => totalJobs.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active Jobs",
              value: () => activeJobs.toString(),
              valueColor: "success.main",
            },
            {
              title: "High Priority",
              value: () => highPriorityJobs.toString(),
              valueColor: "error.main",
            },
            {
              title: "Total Budget",
              value: () =>
                `$${((totalBudget as number) / 1000000).toFixed(1)}M`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["jobNumber"],
          sortDirection: { jobNumber: "DESC" },
        },
      },
    },
  },
  {
    name: "job-schedule",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.jobScheduleStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalSchedules = entities.length;
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const todaySchedules = entities.filter(
            (schedule: Record<string, unknown>) => {
              const scheduleDate = new Date(schedule.date as string);
              scheduleDate.setHours(0, 0, 0, 0);
              return scheduleDate.getTime() === today.getTime();
            }
          ).length;
          const thisWeekSchedules = entities.filter(
            (schedule: Record<string, unknown>) => {
              const scheduleDate = new Date(schedule.date as string);
              const weekAgo = new Date();
              weekAgo.setDate(weekAgo.getDate() - 7);
              return scheduleDate >= weekAgo && scheduleDate <= new Date();
            }
          ).length;
          const overdueSchedules = entities.filter(
            (schedule: Record<string, unknown>) => {
              const scheduleDate = new Date(schedule.date as string);
              return scheduleDate < today && schedule.status !== "completed";
            }
          ).length;

          return [
            {
              title: "Total Schedules",
              value: () => totalSchedules.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Today",
              value: () => todaySchedules.toString(),
              valueColor: "success.main",
            },
            {
              title: "This Week",
              value: () => thisWeekSchedules.toString(),
              valueColor: "info.main",
            },
            {
              title: "Overdue",
              value: () => overdueSchedules.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  // Job Dashboard critical stores
  {
    name: "job-stats/finishing-count",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "job-stats/casting-dates",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "job-stats/hardware-count",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "job-stats/ifc-status",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "job-stats/panel-count",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "job-stats/trailer-loads",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
];